export default __webpack_public_path__ + "static/media/NAM.71148fb1.svg";